/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import P1 from './p1.png';
import P2 from './p2.png';
import P3 from './p3.png';
import P4 from './p4.png';
import P5 from './p5.png';
import P6 from './p6.png';
import P7 from './p7.png';
import P8 from './p8.png';
import P9 from './p9.png';
import P10 from './p10.png';
import P11 from './p11.png';
import P12 from './p12.png';
import P13 from './p13.png';
import P14 from './p14.png';
import P15 from './p15.png';
import P16 from './p16.png';
import P17 from './p17.png';
import P18 from './p18.png';
import P19 from './p19.png';
import P20 from './p20.png';
import P21 from './p21.png';
import P22 from './p22.png';
import P23 from './p23.png';
import P24 from './p24.png';

export default [
    P1,
    P2,
    P3,
    P4,
    P5,
    P6,
    P7,
    P8,
    P9,
    P10,
    P11,
    P12,
    P13,
    P14,
    P15,
    P16,
    P17,
    P18,
    P19,
    P20,
    P21,
    P22,
    P23,
    P24,
];